import { Box, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import CarFilter from '../CarFilter';

import useStyles from './styles';
interface IModalProps {
  open: boolean;
  handleClose: () => void;
  handlecancel: () => void;
  handleBack: () => void;
}
const ModalFiltersMobile = (props: IModalProps) => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby=""
        classes={{ paper: classes.dialogPaper }}
      >
        <Typography className={classes.title}>
          Filtros de Busca
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          marginTop='25px'
        >
          <CarFilter />

          <Button
            variant="outlined"
            onClick={props.handlecancel}
            className={classes.button}
          >
            Fechar
          </Button>
        </Box>
      </Dialog>
    </>
  );
};
export default ModalFiltersMobile;
